import { supabase } from '../lib/supabase';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { theme } from '../theme';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');
  setLoading(true);

  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email: email,
      password: password,
    });

    if (error) throw error;

    // Success! Navigate to dashboard
    navigate('/dashboard');
  } catch (error) {
    setError(error.message || 'Failed to sign in');
    console.error('Login error:', error);
  } finally {
    setLoading(false);
  }
};

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>My Greatest Self</h1>
        <p style={styles.subtitle}>Welcome back</p>
        
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              placeholder="you@example.com"
              required
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              placeholder="••••••••"
              required
            />
          </div>

          {error && <div style={styles.error}>{error}</div>}

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p style={styles.footer}>
          Don't have an account?{' '}
          <span 
            style={styles.link} 
            onClick={() => navigate('/signup')}
          >
            Sign up
          </span>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.bgDark,
    padding: '20px',
  },
  card: {
    backgroundColor: theme.colors.bgMedium,
    borderRadius: '12px',
    padding: '40px',
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
  },
  title: {
    fontSize: '2rem',
    fontWeight: '700',
    background: theme.colors.gradient,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    marginBottom: '8px',
    textAlign: 'center',
  },
  subtitle: {
    color: theme.colors.textSecondary,
    textAlign: 'center',
    marginBottom: '32px',
    fontSize: '1rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  label: {
    color: theme.colors.textSecondary,
    fontSize: '0.875rem',
    fontWeight: '500',
  },
  input: {
    backgroundColor: theme.colors.bgLight,
    border: `1px solid ${theme.colors.bgLight}`,
    borderRadius: '8px',
    padding: '0.75em 1em',
    color: theme.colors.textPrimary,
    fontSize: '1rem',
    outline: 'none',
    transition: 'border-color 0.2s',
  },
  button: {
    background: theme.colors.gradient,
    border: 'none',
    borderRadius: '8px',
    padding: '0.875em',
    color: 'white',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '8px',
    transition: 'opacity 0.2s',
  },
  error: {
    backgroundColor: '#dc2626',
    color: 'white',
    padding: '12px',
    borderRadius: '8px',
    fontSize: '0.875rem',
  },
  footer: {
    textAlign: 'center',
    marginTop: '24px',
    color: theme.colors.textMuted,
    fontSize: '0.875rem',
  },
  link: {
    color: theme.colors.teal,
    cursor: 'pointer',
    fontWeight: '600',
  },
};

export default Login;